import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "@/store";

const initialState = { role: { role: "", role_id: "" } } as IUser;

const userViewSlice = createSlice({
    name: "userView",
    initialState,
    reducers: {
        setUserView: (state, action) => {
            const { id, email, name, username, phone, role, status, mmc, facilities } = action.payload;
            state.id = id;
            state.email = email;
            state.name = name;
            state.username = username;
            state.phone = phone;
            state.role = role;
            state.status = status;
            state.mmc = mmc;
            state.facilities = facilities;
        },
    },
});

export const { setUserView } = userViewSlice.actions;
export default userViewSlice.reducer;

export const getUserView = (state: RootState) => state.userView;
